module.exports = __webpack_public_path__ + "img/td_C3.2.3255b769.png";